import { Button, CircularProgress } from "@mui/material";
import React from "react";
import { AddressTestingStyles } from "../common/styles/AddressTesting.styles";
import clsx from "clsx";
type FooterButtonsProps = {
  step: number;
  isLoading: boolean;
  disabled: boolean;
  emailVerified: boolean;
  handleAddAnother: () => void;
  handleNextClick: () => void;
};

const isNextButtonDisabled = (step: number, emailVerified: boolean, disabled: boolean): boolean => {
  if (disabled) return true;
  // After D3 the verify (email/2FA) step is now step 4; the original gate
  // was on `step === 2` when verify was the second step.
  if (step === 4) return !emailVerified;
  return false;
};

const AddressFooterButtons: React.FC<FooterButtonsProps> = ({
  step,
  isLoading,
  emailVerified,
  handleAddAnother,
  handleNextClick,
  disabled,
}) => {
  const classes = AddressTestingStyles();

  if (isLoading) {
    return (
      <Button disableRipple disabled={true} className={classes.nextBtn}>
        <CircularProgress size={20} />
      </Button>
    );
  }

  // Success is now step 5 post-D3.
  const buttonText = step === 5 ? "Add Another Address" : "Next";
  const buttonOnClick = step === 5 ? handleAddAnother : handleNextClick;

  return (
    <Button
      disableRipple
      onClick={buttonOnClick}
      disabled={isNextButtonDisabled(step, emailVerified, disabled)}
      className={clsx(classes.nextBtn, {
        [classes.nextBtnDisabled]: isNextButtonDisabled(step, emailVerified, disabled),
      })}>
      {buttonText}
    </Button>
  );
};

export default AddressFooterButtons;
